import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5276bb33"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_aside",
  class: "aside aside-dark",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "aside",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
}
const _hoisted_2 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_3 = { href: "#" }
const _hoisted_4 = {
  key: 0,
  href: "#"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  href: "#"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrows-collapse fs-4 me-1" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_aside_toggle\" class=\"btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle text-white\" data-kt-toggle=\"true\" data-kt-toggle-state=\"active\" data-kt-toggle-target=\"body\" data-kt-toggle-name=\"aside-minimize\" data-v-5276bb33><span class=\"svg-icon svg-icon-1 rotate-180 svg-icon-light\" data-v-5276bb33><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-5276bb33><path opacity=\"0.5\" d=\"M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z\" fill=\"black\" data-v-5276bb33></path><path d=\"M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z\" fill=\"black\" data-v-5276bb33></path></svg></span></div>", 1)
const _hoisted_12 = { class: "aside-menu flex-column-fluid" }
const _hoisted_13 = {
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  id: "kt_aside_menu_wrapper",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-wrappers": "#kt_aside_menu",
  "data-kt-scroll-offset": "0"
}
const _hoisted_14 = {
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  id: "#kt_aside_menu",
  "data-kt-menu": "true"
}
const _hoisted_15 = {
  key: 0,
  class: "accordion-item border-0 bg-transparent"
}
const _hoisted_16 = ["id", "data-bs-target"]
const _hoisted_17 = { class: "menu-icon" }
const _hoisted_18 = { class: "menu-title fs-5 ls-1 text-white" }
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "menu-icon" }
const _hoisted_21 = { class: "menu-title fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        (_ctx.asideTheme == 'dark')
          ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
              _createElementVNode("img", {
                alt: "Logo",
                src: _ctx.themeDarkLogo,
                class: "h-55px logo"
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
        (_ctx.asideTheme == 'light')
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
              _createElementVNode("img", {
                alt: "Logo",
                src: _ctx.themeLightLogo,
                class: "h-55px logo"
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("img", {
          src: _ctx.logoIcon,
          class: "w-40px logoIcon"
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: "text-end me-5 mb-3 text-white hand-cursor",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapseAll())),
          title: "Collapse all"
        }, _hoisted_10),
        _hoisted_11
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (_ctx.hasModulePermissionWrapper(item.permissionGroup))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", {
                      id: item.section + item.section,
                      class: "menu-link accordion-button border-0 bg-transparent py-3 shadow-none text-hover-white side-menu-class",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#menu-section-${i}`
                    }, [
                      _createElementVNode("span", _hoisted_17, [
                        _createElementVNode("i", {
                          class: _normalizeClass([item.fontIcon, "fs-3"])
                        }, null, 2)
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(item.section), 1)
                    ], 8, _hoisted_16),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.menus, (menuItem, j) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                        (_ctx.hasPermissionWrapper(menuItem.permission))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "accordion-collapse collapse menu-item site-menu-item-class",
                              id: `menu-section-${i}`
                            }, [
                              _createVNode(_component_router_link, {
                                class: "menu-link text-hover-white",
                                to: menuItem.route
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_20, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass([menuItem.fontIcon, "fs-5"])
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ], 8, _hoisted_19))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ])
  ]))
}